import { createContext } from 'react';
import type { SmartBreadcrumbItem } from './BreadcrumbsBuilder';

export type BreadcrumbLayer = {
  id: string;
  items: SmartBreadcrumbItem[];
  priority: number;
  order: number;
};

export type BreadcrumbsContextValue = {
  setLayer: (
    id: string,
    items: SmartBreadcrumbItem[],
    priority: number,
  ) => void;
  clearLayer: (id: string) => void;
  items: SmartBreadcrumbItem[];
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextValue | null>(
  null,
);
